import { useState } from 'react'
import type { OnChangeFn, SortingState } from '@tanstack/react-table'

function useFilters() {
  const [isFilterOpen, setFilterOpen] = useState(false)
  function toggleFilterOpen() {
    setFilterOpen((isFilterOpen_) => !isFilterOpen_)
  }

  const [sorting, setSorting] = useState<SortingState>([])
  const handleSortingChange: OnChangeFn<SortingState> = (_sorting) => {
    setSorting(_sorting)
  }

  return {
    isFilterOpen,
    toggleFilterOpen,

    sorting,
    setSorting,
    handleSortingChange,
  }
}

export { useFilters }
